module.exports = __webpack_public_path__ + "img/lifestyle-racing.30de3292.jpg";